module.exports = __webpack_public_path__ + "files/d853340489e1f86dab632c37f541011d.svg";